<template>
  <div class="result-operation">
    <h2>{{ operation.name }}</h2>
    <p v-html="description"></p>

    <div>
      <hr />
      <div v-for="recipe in operation.recipes" :key="recipe.id">
        <result-page-recipe :recipe="recipe" :compact="!currentUser.authenticated" />
        <hr />
      </div>
    </div>

    <result-page-operation-sum-table :operation="operation" />
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';
  import ResultPageRecipe from './ResultPageRecipe'
  import ResultPageOperationSumTable from './ResultPageOperationSumTable'

  export default {
    props: ['operation'],
    components: {
      ResultPageRecipe,
      ResultPageOperationSumTable
    },
    computed: {
      ...mapGetters('user', [
        'currentUser'
      ]),
      description() {
        return (this.operation.description || '').replace(/(?:\r\n|\r|\n)/g, '<br />');
      }
    }
  }
</script>


<style scoped>
  hr {
    border: 0;
    height: 5px;
    color: green;
    background-color: green;
    margin-top: 50px;
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResultPageOperation.vue